import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-partial-payment-confirmation',
  templateUrl: './partial-payment-confirmation.component.html',
  styleUrls: ['./partial-payment-confirmation.component.scss']
})
export class PartialPaymentConfirmationComponent implements OnInit {

  @Input() entity
  constructor() { }

  ngOnInit(): void {
  }

}
